import { partnerClient } from '@modules/core/services';
import { DEFAULT_STUDY_ID } from '@/modules/study-insights/constants';
import {
  CommunityOutreachFormValues,
  OutreachLocationResponse,
} from '../components/CommunityOutreachForm/CommunityOutreachForm.types';

const getPath = (id: string): string => {
  return `/studies/${id}/e-consent`;
};

export const submitInquiryForm = async (
  data: CommunityOutreachFormValues,
  studyId = DEFAULT_STUDY_ID,
): Promise<any> => {
  const path = getPath(studyId);
  const response = await partnerClient.post(path, data);

  return response?.data;
};

export const getOutreachLocation = async (): Promise<OutreachLocationResponse[]> => {
  const response = await partnerClient.get(`partners/enrollment_locations`);

  return response as any;
};
